<app-header></app-header>

<section class="sec">

    <p>Pepiniera s-a dezvoltat repede, oferind specii si soiuri noi, datorita multor cumparatori multumiti. Reproducerea
        in cantitate mare, face posibil ca la unele plante sa putem oferi preturi avantajoase. La sediul nostru din
        ARAD, cartier Gradiste, va oferim in cantitati mai mici, specii care nu sunt trecute in catalog, pe site.</p>

    <p> Plantele ce lipsesc vi-i le procuram la pret convenabil pentru dumneavoastra.</p>

    <p> Preturile afisate sunt cu titlu informativ, ele putand varia in functie de marimea,specia si cantitatea
        plantelor achizitionate.</p>

    <p> Daca catalogul nostru v-a atras atentia, va rugam sa faceti o vizita la noi si speram sa va putem oferi solutia
        cea mai rezonabila.</p>

    <p class="text-center"> Va multumim pentru increderea acordata si asteptam comenzile dumneavoastra.</p>
</section>
<hr>
<section class="news">
    <h1 class="text-center">Promotii si reduceri</h1>
    <app-news></app-news>
</section>
<hr>
<section class="sec1 ">

    <div class="row rand1 ">
        <!-- tuia -->
        <div class="col-xl-4 col-sm-12 col-md-6 col-xs-12 d-flex justify-content-center ">
            <!-- tuia -->
            <figure class="snip1543" id="cat1">
                <!-- <img src="assets/pics/1.jpg" alt="sample108" /> -->
                <figcaption>
                    <h1>Tuja si Chiparos</h1>
                    <p>Plante conifere</p>
                </figcaption>
                <a class="btn" routerLink="/tuja" role="button" style="background-color: rgba(14, 110, 110);"> Mai
                    multe
                    detalii</a>
            </figure>
        </div>
        <!-- brazi -->
        <div class="col-xl-4 col-sm-12 col-md-6 col-xs-12 d-flex justify-content-center">
            <figure class="snip1543 " id="cat2">
                <!-- <img src="assets/pics/2.jpg" alt="sample100" /> -->
                <figcaption>
                    <h1>Brazi si Pini</h1>
                    <p>Plante conifere</p>
                </figcaption>
                <a class="btn" routerLink="/brazi" role="button" style="background-color: rgba(14, 110, 110);"> Mai
                    multe
                    detalii</a>
            </figure>
        </div>
        <!-- ienupari -->
        <div class="col-xl-4 col-sm-12 col-md-6 col-xs-12 d-flex justify-content-center">
            <figure class="snip1543" id="cat3">
                <!-- <img src="assets/pics/4.jpg" alt="sample101" /> -->
                <figcaption>
                    <h1>Ienupari</h1>
                    <p>Plante conifere</p>
                </figcaption>
                <a class="btn" routerLink="/ienupar" role="button" style="background-color: rgba(14, 110, 110);">
                    Mai multe
                    detalii</a>
            </figure>
        </div>

        <!-- flori -->
        <div class="col-xl-4 col-sm-12 col-md-6 col-xs-12 d-flex justify-content-center">
            <figure class="snip1543" id="cat4">
                <!-- <img src="assets/pics/1.jpg" alt="sample108" /> -->
                <figcaption>
                    <h1>Flori</h1>
                    <p>Plante decorative</p>
                </figcaption>
                <a class="btn" routerLink="/flori" role="button" style="background-color: rgba(14, 110, 110);"> Mai
                    multe
                    detalii</a>
            </figure>
        </div>
        <!-- diverse -->
        <div class="col-xl-4 col-sm-12 col-md-6 col-xs-12 d-flex justify-content-center">
            <figure class="snip1543" id="cat5">
                <!-- <img src="assets/pics/2.jpg" alt="sample100" /> -->
                <figcaption>
                    <h1>Plante Diverse</h1>
                    <p>Plante decorative</p>
                </figcaption>
                <a class="btn" routerLink="/diverse" role="button" style="background-color:rgba(14, 110, 110);">
                    Mai multe
                    detalii</a>
            </figure>
        </div>
        <!-- sfaturi -->
        <div class="col-xl-4 col-sm-12 col-md-6 col-xs-12 d-flex justify-content-center ">
            <figure class="snip1543" id="cat6">
                <!-- <img src="assets/pics/4.jpg" alt="sample101" /> -->
                <figcaption>
                    <h1>Descarca Ultimul Catalog</h1>

                </figcaption>
                <a class="btn" download="CATALOG" href="assets/catalog/Catalog.xlsx" role="button"
                    style="background-color: rgba(14, 110, 110);">Descarca</a>
            </figure>
        </div>
    </div>





</section>

<hr>